module.exports = __webpack_public_path__ + "static/blankMobileBack-e33f03e87fee00e61c39ab496db61840.jpg";